import { render, staticRenderFns } from "./lotteryResume.vue?vue&type=template&id=1451a3fa&scoped=true&lang=html&"
import script from "./lotteryResume.vue?vue&type=script&lang=js&"
export * from "./lotteryResume.vue?vue&type=script&lang=js&"
import style0 from "./lotteryResume.vue?vue&type=style&index=0&id=1451a3fa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1451a3fa",
  null
  
)

export default component.exports